import type { Root } from 'react-dom/client';
import reportWebVitals from '../reportWebVitals';
import { isHomeLandingPath } from '../shared-lib/utils/public-marketing-path';
import { loadFullAppStyles, loadHomeShellStyles } from '../shared-lib/utils/deferred-app-styles';
import {
  ensureHomeShellHeaderStyles,
  preloadHeaderLogo,
  preloadHomeShellHeader,
  preloadHomeShellSignalR,
} from '../virtco/components/home-landing-page/home-landing-preload';
import { deferNonCriticalWork } from '../shared-lib/utils/performance-utils';
import { installStripeFloatingIframeCleanup } from '../shared-lib/stripe/install-stripe-floating-iframe-cleanup';

export const isHomeShellEntry =
  typeof window !== 'undefined' && isHomeLandingPath(window.location.pathname);

export function applyShellStyles(): void {
  if (isHomeShellEntry) {
    require('../index-home-minimal.scss');
    loadHomeShellStyles();
    void preloadHomeShellHeader();
    void ensureHomeShellHeaderStyles();
    void preloadHeaderLogo();
    void preloadHomeShellSignalR();
    deferNonCriticalWork(() => {
      require('../shared-lib/error-logger/global-error-logger');
      require('../shared-lib/utils/global-scroll-lock');
      require('../shared-lib/utils/global-scroll-lock.scss');
    }, 5000);
    return;
  }

  require('../index.scss');
  loadFullAppStyles();
  // Theme tokens live on body.client-light / .consultant-dark — apply before React
  // mounts so a hard refresh does not paint with missing CSS variables.
  const { applyBodyClassForPath } = require('../shared-lib/utils/shell-upgrade');
  applyBodyClassForPath(window.location.pathname);
  require('../shared-lib/error-logger/global-error-logger');
  require('../shared-lib/utils/global-scroll-lock');
  require('../shared-lib/utils/global-scroll-lock.scss');
}

export function applyRuntimeSideEffects(): void {
  if (isHomeShellEntry) {
    deferNonCriticalWork(() => reportWebVitals(), 8000);
    deferNonCriticalWork(() => installStripeFloatingIframeCleanup(), 6000);
    return;
  }

  reportWebVitals();
  installStripeFloatingIframeCleanup();
}

export function registerProductionServiceWorker(): void {
  // Production service worker registration is stopped.
  /*
  if (!('serviceWorker' in navigator) || process.env.NODE_ENV !== 'production') {
    return;
  }

  const registerServiceWorker = () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((error) => {
        console.warn('[SW] registration failed:', error?.message || error);
      });
  };

  if (isHomeShellEntry) {
    window.addEventListener(
      'load',
      () => {
        deferNonCriticalWork(registerServiceWorker, 10000);
      },
      { once: true }
    );
    return;
  }

  window.addEventListener('load', registerServiceWorker, { once: true });
  */
}

export function mountApplicationRoot(root: Root): void {
  if (isHomeShellEntry) {
    import('./home-shell-entry').then(({ mountHomeShell }) => {
      mountHomeShell(root);
    });
    return;
  }

  import('./full-app-entry').then(({ mountFullApp }) => {
    mountFullApp(root);
  });
}
